import { Injectable } from '@angular/core';
import { HttpClient,HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AdminServicesService {

  public baseUrl="https://9h6bwbaajf.execute-api.ap-south-1.amazonaws.com/dev/";

  // public baseUrl="http://192.168.1.104:2528/";
  constructor(private http:HttpClient,
    public router:Router) { }

  public dropdownScope()
  {
    return this.http.get(`${this.baseUrl}get_roles`);
  }

  public loginAdmin(data)
  {
    return this.http.post(`${this.baseUrl}get_loginDtls/`, data);
  }

  public register(data)
  {
    return this.http.post(`${this.baseUrl}user_registration`,data);
  }

  public logout()
  {
    let a = JSON.parse(localStorage.getItem('userDetails'));
    if(a==null)
    {
      this.router.navigate(['login-admin']);
    }

    else {
    return this.http.get(`${this.baseUrl}logout_admin/`+ a.userId);
    }
  }

  public changepwd(data)
  {
    return this.http.post(`${this.baseUrl}change_pswd_admin`,data);
  }

  // @@@@@@@@@@@@@@@@

  // Chart Api's

  public chart()
  {
    return this.http.get(`${this.baseUrl}count_dashbord_allModules`);
  }

  // @@@@@@@@@@@

  // Manage Clients --> All Clients
  public allClients()
  {
    return this.http.get(`${this.baseUrl}all_clients`);
  }


  // @@@@@@@@@@@@@@@@@

  // Settings -->  View Referral History
  public contactus()
  {
    return this.http.get(`${this.baseUrl}get_Reffreals_History`);
  }

   // Settings -->  View Contact Us
   public viewContactus()
   {
     return this.http.get(`${this.baseUrl}get_ContactUs`);
   }

    // Settings --> View Lead History
    public leadHistory(data)
    {
      return this.http.get(`${this.baseUrl}all_Leads/`+data.user_id);
    }


    // @@@@@@@@@@@@@@@@@

    public bulkUpload(data:any)
    { 
      return this.http.post(`${this.baseUrl}bulkUploads`,data);
      // return this.http.post(`${this.localUrl}bulkUploads`,data);
    }

    // bulkUpload --> Click in Inserted DataForm
    public insertedClick(data)
    {
      return this.http.post(`${this.baseUrl}lead_invitation_mail`,data);
    }

    //Manage Leads --> Add Leads --> Dropdown
    public referred()
    {
      return this.http.get(`${this.baseUrl}allLeads_dropwond`);
    }

    //Manage Leads --> Add Leads
    public addlead(data)
    {
      return this.http.post(`${this.baseUrl}add_Lead`,data);
    }

    // Manage Clients --> Client Documents
    public clientDocuments()
    {
      return this.http.get(`${this.baseUrl}all_usser_files_adminDash`);
    }

    //Manage Return Tax --> Upload Return Tax --> Dropdown
    public uploadDropdown()
    {
      return this.http.get(`${this.baseUrl}allUsers_dropwond`);
    }

    //Manage Return Tax --> Upload Return Tax 
    public uploadReturnTax(data)
    {
      return this.http.post(`${this.baseUrl}retax_fileUpload`,data);
    }

    //settings --> View File Download History
    public fileDownloadHistory()
    {
      return this.http.get(`${this.baseUrl}file_download_history`);
    }

    // whishlists
    public wishlist()
    {
      return this.http.get(`${this.baseUrl}get_ip_wishList`);
    }

    public updateWishlist(data)
    {
      return this.http.post(`${this.baseUrl}update_get_ip_wishList`,data);
    }
}
